type CachedObjectFactory<T> = () => T;

export class Lazy<T> {
  private readonly objectFactory: CachedObjectFactory<T>;
  private _cache: T;
  private _isUpToDate: boolean = false;

  constructor(objectFactory: CachedObjectFactory<T>) {
    this.objectFactory = objectFactory;
  }

  public call(updateCache: boolean = false): T {
    if (updateCache || !this._isUpToDate) {
      this._isUpToDate = true;
      return (this._cache = this.objectFactory());
    } else {
      return this._cache;
    }
  }

  public updateCache(): void {
    this._isUpToDate = false;
  }

  public get isUpToDate(): boolean {
    return this._isUpToDate;
  }

  public toString(): string {
    const data = this.call();
    const className = data?.constructor?.name || 'T';
    return `Lazy<${className}>: ${data}`;
  }
}
